<template>
  <ul class="FaqList">
    <li class="FaqList__item" v-for="item in response" :key="item.id">
      <router-link :to="`/faq/item/${item.id}`" class="FaqList__link">
        {{ item.question }}
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'FaqList',
  props: {
    response: {
      type: Array,
      require: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.FaqList {
  @include list-reset;

  display: flex;
  flex-direction: column;

  &__item {
    display: flex;
    margin-bottom: 15px;
    line-height: 20px;
    background-color: $color-white;
    border-radius: 2px;
    box-shadow: $box-shadow-card-1;
  }

  &__link {
    @include a-reset;

    position: relative;
    padding: 20px;
    font-size: rem(14);
    line-height: 20px;

    &::before {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      width: 0;
      content: '';
      background-color: $accent;
      transition: width $A;
    }

    &:hover::before {
      width: 4px;
    }
  }
}
</style>
